<template>
	<Tab :class="{ open }" v-bind="$props" @toggle="toggle">
		<template v-slot:header>
			<TabHeader
				icon="aluminium"
				label="Aluminium cans"
				:value="value"
				:open="open"
			/>
		</template>
		<template v-slot:content>
			<Corridor>
				<p class="tab__prompt">
					How many canned beverages does your household drink each week?
				</p>
				<div class="tab__sliders">
					<Slider
						v-for="slider in sliders"
						:key="slider.label"
						v-bind="slider.data"
						v-model="slider.slider"
						@dragend="trackSlider(slider.data)"
					/>
				</div>
			</Corridor>
		</template>
	</Tab>
</template>

<script>
import tab from '@/mixins/tab'
import sliders from '@/mixins/sliders'
import sliderAnalytics from '@/mixins/sliderAnalytics'

const SLIDERS = [
	{ title: 'Soft drink' },
	{ title: 'Alcohol' },
	{ title: 'Energy drinks' }
]

export default {
	name: 'TabAluminium',
	mixins: [tab, sliders(SLIDERS), sliderAnalytics('Aluminium Cans')]
}
</script>

<style lang="scss" scoped>
@import '~scss/mixins';
@include tab($green-61);
</style>
